module.exports = vendors_3afde33975bb9ac5144a;